

import { Link, useLocation } from 'react-router-dom';

const NavBarItems = ({ componentName, changeComponent }) => {
  const { pathname, search } = useLocation();
  const tikNumURL = new URLSearchParams(search).get("TikNum");
  const systemCodeURL = new URLSearchParams(search).get("SystemCode");

  const CustomItem = ({ name, children, ...props }) => {
    return (
      <li className={"navbar-item" + (componentName === name ? " active" : "")}>
        {/* <a className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</a> */}
        <Link to={`${pathname}?TikNum=${tikNumURL}&SystemCode=${systemCodeURL}&Page=${name}`} className={"navbar-link"} onClick={() => changeComponent(name)}>{children}</Link>

      </li>
    )
  }
  
  return (
    <nav className="navbar">
      <div className="container">
        <ul className="navbar-tabs">
          <CustomItem name="BakashalInfo">תיאור הבקשה</CustomItem>
          <CustomItem name="ProcessInfo">תהליך</CustomItem>
          <CustomItem name="VahadaInfo">החלטות הוועדה</CustomItem>
          <CustomItem name="LocationInfo">נתוני מקום</CustomItem>
          <CustomItem name="AreasInfo">שטחים</CustomItem>
          <CustomItem name="TnaimInfo">תנאים לקידום תיק</CustomItem>
          <CustomItem name="ArchivInfo">ארכיב אופטי</CustomItem>
        </ul>
      </div>
    </nav>
  )
}

export default NavBarItems;